// authProvider.ts
import configData from "../config.json";
import { getQuery, makeId, parseQuery } from "../utils/helper";

const authorizeEndpoint = configData.AuthorizeEndpoint;
const tokenEndpoint = configData.TokenEndpoint;
const clientId = configData.ClientId;
const redirectUri = configData.RedirectFrontUri;

let jwtOriginalAppUrl = window.location.href;
let jwtBlockRedirectFlag = false;
let jwtBlockHttpRequest = true;

export const redirectForAuthorization = (location?: string): void => {
  if (!jwtBlockRedirectFlag) {
    jwtBlockRedirectFlag = true;
    sessionStorage.setItem("codeVerifier", makeId(44));
    const codeVerifier = sessionStorage.getItem("codeVerifier")!;
    const authorizeUrl = `${authorizeEndpoint}?response_type=code&scope=openid&client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&code_challenge=${encodeURIComponent(
      codeVerifier
    )}&code_challenge_method=plain`;

    window.location.href = authorizeUrl;
  }
};

export const isRequestBlocked = (): boolean => {
  return jwtBlockHttpRequest;
};

export const getJwtTokenAsync = async (): Promise<void> => {

  try {
    const location = localStorage.getItem("location");
    const query = parseQuery(getQuery(jwtOriginalAppUrl));
    if (!query.code) {
      jwtBlockHttpRequest = false;
      return;
    }

    const codeVerifier = sessionStorage.getItem("codeVerifier")!;
    const postContent = new URLSearchParams({
      grant_type: "authorization_code",
      code: query.code,
      redirect_uri: redirectUri,
      client_id: clientId,
      code_verifier: codeVerifier,
    }).toString();

    const response = await fetch(tokenEndpoint, {
      method: "POST",
      mode: "cors",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: postContent,
    });

    if (!response.ok) {
      jwtBlockHttpRequest = false;
      return;
    }

    const json = await response.json();
    localStorage.setItem("jwttoken", json.access_token);
    jwtBlockHttpRequest = false;
    if (location) window.location.href = location;
  } catch (err) {
    jwtBlockHttpRequest = false;
  } finally {
    localStorage.removeItem("location");
  }
};
